export default {
  en: {
    elements: {
      title: 'Elements',
      placeholderSearch: 'Search element',
      text: {
        label: 'Text',
        description: 'One line text field',
      },
      textarea: {
        label: 'Text area',
        description: 'Single or multi-line text field'
      },
      email: {
        label: 'Email',
        description: 'Formatted email'
      },
      mobile: {
        label: 'Phone number',
        description: 'Telephone or mobile number',
      },
      url: {
        label: 'Website',
        description: 'Formatted link',
      },
      select: {
        label: 'Single selection',
        description: 'Dropdown with single selection'
      },
      radio: {
        label: 'Selection box',
        description: 'Single list selection',
      },
      checkbox: {
        label: 'Multiselect box',
        description: 'Multi-selection list'
      },
      time: {
        label: 'Hour',
        description: 'Hour and minutes selection',
      },
      number: {
        label: 'Number',
        description: 'Field of numbers only',
      },
      date: {
        label: 'Date',
        description: 'Date with day, month and year',
      },
      multiselect: {
        label: 'Multiselect',
        description: 'Multi-selection dropdown list'
      },
      password: {
        label: 'Password',
        description: 'Hidden password input',
      },
      color: {
        label: 'Color',
        description: 'RBG color selector',
      },
      range: {
        label: 'Custom range',
        description: 'Custom range selector',
      },
      nps: {
        label: 'Net Promoter Score™',
        description: 'Measure the customer\'s loyalty',
      },
      ces: {
        label: 'Customer Effort Score',
        description: 'Measure satisfaction vs effort'
      },
      csat: {
        label: 'Customer Satisfaction Score',
        description: 'Measure customer\'s satisfaction'
      }
    },
    options: {
      selectColor: 'Select a color',
      optionValuePlaceholder: 'Unique ID',
      optionLabelPlaceholder: 'Visible title',
      confirmDelete: 'Confirm you want to delete?',
      labelPlaceholder: 'Question title',
      hintPlaceholder: 'Placeholder',
      idPlaceholder: 'Unique ID'
    },
    content: {
      dragArea: 'Drag an element and drop it here',
      fieldPreview: 'Field preview',
    },
    attributes: {
      readonly: 'Readonly',
      disabled: 'Disabled',
      maxlength: 'Maximum length of characters',
      minlength: 'Minimum length of characters',
      pattern: 'Regex pattern',
      placeholder: 'Help message',
      required: 'Required',
      min: 'Minimum number',
      max: 'Maximum number',
    },
    dataCategory: {
      label: 'Data classification',
      placeholder: 'Select the type of data collected',
      groups: {
        general: 'General personal data',
        sensitive: 'Sensitive data',
        none: 'Non-personal data',
      },
      categories: {
        identification: 'Identification',
        national_id: 'National ID / document',
        contact: 'Contact details',
        demographic: 'Demographic data',
        location: 'Location',
        financial: 'Financial data',
        professional: 'Professional data',
        health: 'Health',
        genetic: 'Genetic data',
        biometric: 'Biometric data',
        racial_ethnic: 'Racial or ethnic origin',
        political: 'Political opinions',
        union: 'Trade-union membership',
        religious_philosophical: 'Religious or philosophical beliefs',
        sexual: 'Sex life or sexual orientation',
        socioeconomic: 'Socioeconomic situation',
        minors: 'Data of minors',
        other: 'Other personal data',
        non_personal: 'Not personal data',
      },
    },
    dummy: {
      defaultTitle: 'Title of the field',
      enterText: 'Enter a text',
      enterEmail: 'Enter an email',
      enterPhone: 'Enter a phone number',
      chooseDate: 'Select a date',
      chooseMonth: 'Select a month',
      chooseTime: 'Choose a date',
      enterNumbers: 'Enter numbers',
      enterUrl: 'Enter a url',
      enterPassword: 'Enter a password',
      chooseColor: 'Choose a color',
      chooseOption: 'Select an option',
      chooseOptions: 'Select options from the list',
      npsTitle: 'Do you would recommend our service to friends?',
      cesTitle: 'How easy was it to resolve your issue today?',
      csatTitle: 'How satisfied are you with your most recent interaction with our company?'
    },
  },
  es: {
    elements: {
      title: 'Elementos',
      placeholderSearch: 'Buscar elemento',
      text: {
        label: 'Texto',
        description: 'Campo de texto de una línea',
      },
      textarea: {
        label: 'Área de texto',
        description: 'Campo de texto de una o varias líneas'
      },
      email: {
        label: 'Correo electrónico',
        description: 'Correo electrónico formateado'
      },
      mobile: {
        label: 'Número de teléfono',
        description: 'Número de teléfono o móvil',
      },
      url: {
        label: 'Sitio web',
        description: 'Enlace formateado',
      },
      select: {
        label: 'Selección única',
        description: 'Desplegable con selección única'
      },
      radio: {
        label: 'Caja de selección',
        description: 'Selección de lista única',
      },
      checkbox: {
        label: 'Caja de multiselección',
        description: 'Lista de multi-selección'
      },
      time: {
        label: 'Hora',
        description: 'Selección de hora y minutos',
      },
      number: {
        label: 'Número',
        description: 'Campo solo de números',
      },
      date: {
        label: 'Fecha',
        description: 'Fecha con día, mes y año',
      },
      multiselect: {
        label: 'Multiselección',
        description: 'Lista desplegable de multi-selección'
      },
      password: {
        label: 'Contraseña',
        description: 'Entrada de contraseña oculta',
      },
      color: {
        label: 'Color',
        description: 'Selector de color RBG',
      },
      range: {
        label: 'Rango personalizado',
        description: 'Selector de rango personalizado',
      },
      nps: {
        label: 'Net Promoter Score™',
        description: 'Medir la lealtad del cliente',
      },
      ces: {
        label: 'Customer Effort Score',
        description: 'Medir satisfacción vs esfuerzo'
      },
      csat: {
        label: 'Customer Satisfaction Score',
        description: 'Medir la satisfacción del cliente'
      }
    },
    options: {
      selectColor: 'Seleccionar un color',
      optionValuePlaceholder: 'ID único',
      optionLabelPlaceholder: 'Título visible',
      confirmDelete: '¿Confirma que desea eliminar?',
      labelPlaceholder: 'Título de la pregunta',
      hintPlaceholder: 'Mensaje de ayuda',
      idPlaceholder: 'ID único'
    },
    content: {
      dragArea: 'Arrastra un elemento y suéltalo aquí',
      fieldPreview: 'Vista previa del campo',
    },
    attributes: {
      readonly: 'Solo lectura',
      disabled: 'Deshabilitado',
      maxlength: 'Longitud máxima de caracteres',
      minlength: 'Longitud mínima de caracteres',
      pattern: 'Patrón Regex',
      placeholder: 'Mensaje de ayuda',
      required: 'Requerido',
      min: 'Número mínimo',
      max: 'Número máximo',
    },
    dataCategory: {
      label: 'Clasificación de datos',
      placeholder: 'Selecciona el tipo de dato recolectado',
      groups: {
        general: 'Datos personales generales',
        sensitive: 'Datos sensibles',
        none: 'Sin dato personal',
      },
      categories: {
        identification: 'Identificación',
        national_id: 'Documento de identidad nacional',
        contact: 'Datos de contacto',
        demographic: 'Datos demográficos',
        location: 'Ubicación',
        financial: 'Datos financieros',
        professional: 'Datos laborales',
        health: 'Salud',
        genetic: 'Datos genéticos',
        biometric: 'Datos biométricos',
        racial_ethnic: 'Origen racial o étnico',
        political: 'Opiniones políticas',
        union: 'Afiliación sindical o gremial',
        religious_philosophical: 'Creencias religiosas o filosóficas',
        sexual: 'Vida sexual u orientación sexual',
        socioeconomic: 'Situación socioeconómica',
        minors: 'Datos de niñas, niños y adolescentes',
        other: 'Otro dato personal',
        non_personal: 'No es dato personal',
      },
    },
    dummy: {
      defaultTitle: 'Título del campo',
      enterText: 'Ingrese un texto',
      enterEmail: 'Ingrese un correo electrónico',
      enterPhone: 'Ingrese un número de teléfono',
      chooseDate: 'Seleccione una fecha',
      chooseMonth: 'Seleccione un mes',
      chooseTime: 'Elija una fecha',
      enterNumbers: 'Ingrese números',
      enterUrl: 'Ingrese una url',
      enterPassword: 'Ingrese una contraseña',
      chooseColor: 'Elija un color',
      chooseOption: 'Seleccione una opción',
      chooseOptions: 'Seleccione opciones de la lista',
      npsTitle: '¿Recomendaría el servicio proporcionado?',
      cesTitle: '¿Qué tan fácil fue resolver su problema hoy?',
      csatTitle: '¿Qué tan satisfecho está con su interacción más reciente con nuestra empresa?'
    },
  },
  fr: {
    elements: {
      title: 'Éléments',
      placeholderSearch: 'Rechercher un élément',
      text: {
        label: 'Texte',
        description: 'Champ de texte sur une ligne',
      },
      textarea: {
        label: 'Zone de texte',
        description: 'Champ de texte sur une ou plusieurs lignes'
      },
      email: {
        label: 'Email',
        description: 'Email formaté'
      },
      mobile: {
        label: 'Numéro de téléphone',
        description: 'Numéro de téléphone ou mobile',
      },
      url: {
        label: 'Site web',
        description: 'Lien formaté',
      },
      select: {
        label: 'Sélection unique',
        description: 'Menu déroulant avec sélection unique'
      },
      radio: {
        label: 'Case de sélection',
        description: 'Sélection dans une liste unique',
      },
      checkbox: {
        label: 'Case à cocher',
        description: 'Liste de sélection multiple'
      },
      time: {
        label: 'Heure',
        description: 'Sélection des heures et des minutes',
      },
      number: {
        label: 'Nombre',
        description: 'Champ réservé aux nombres uniquement',
      },
      date: {
        label: 'Date',
        description: 'Date avec jour, mois et année',
      },
      multiselect: {
        label: 'Sélection multiple',
        description: 'Menu déroulant avec sélection multiple'
      },
      password: {
        label: 'Mot de passe',
        description: 'Champ de saisie de mot de passe caché',
      },
      color: {
        label: 'Couleur',
        description: 'Sélecteur de couleur RGB',
      },
      range: {
        label: 'Plage personnalisée',
        description: 'Sélecteur de plage personnalisée',
      },
      nps: {
        label: 'Net Promoter Score™',
        description: 'Mesurez la fidélité des clients',
      },
      ces: {
        label: 'Customer Effort Score',
        description: 'Mesurez la satisfaction par rapport à l\'effort'
      },
      csat: {
        label: 'Customer Satisfaction Score',
        description: 'Mesurez la satisfaction des clients'
      }
    },
    options: {
      selectColor: 'Sélectionner une couleur',
      optionValuePlaceholder: 'ID unique',
      optionLabelPlaceholder: 'Titre visible',
      confirmDelete: 'Confirmer la suppression?',
      labelPlaceholder: 'Titre de la question',
      hintPlaceholder: 'Texte d\'aide',
      idPlaceholder: 'ID unique'
    },
    content: {
      dragArea: 'Faites glisser un élément et déposez-le ici',
      fieldPreview: 'Aperçu du champ',
    },
    attributes: {
      readonly: 'Lecture seule',
      disabled: 'Désactivé',
      maxlength: 'Longueur maximale des caractères',
      minlength: 'Longueur minimale des caractères',
      pattern: 'Modèle Regex',
      placeholder: 'Message d\'aide',
      required: 'Requis',
      min: 'Nombre minimum',
      max: 'Nombre maximum',
    },
    dataCategory: {
      label: 'Classification des données',
      placeholder: 'Sélectionnez le type de données collectées',
      groups: {
        general: 'Données personnelles générales',
        sensitive: 'Données sensibles',
        none: 'Donnée non personnelle',
      },
      categories: {
        identification: 'Identification',
        national_id: 'Pièce d\'identité nationale',
        contact: 'Coordonnées',
        demographic: 'Données démographiques',
        location: 'Localisation',
        financial: 'Données financières',
        professional: 'Données professionnelles',
        health: 'Santé',
        genetic: 'Données génétiques',
        biometric: 'Données biométriques',
        racial_ethnic: 'Origine raciale ou ethnique',
        political: 'Opinions politiques',
        union: 'Appartenance syndicale',
        religious_philosophical: 'Convictions religieuses ou philosophiques',
        sexual: 'Vie sexuelle ou orientation sexuelle',
        socioeconomic: 'Situation socio-économique',
        minors: 'Données de mineurs',
        other: 'Autre donnée personnelle',
        non_personal: 'N\'est pas une donnée personnelle',
      },
    },
    dummy: {
      defaultTitle: 'Titre du champ',
      enterText: 'Entrez un texte',
      enterEmail: 'Entrez un email',
      enterPhone: 'Entrez un numéro de téléphone',
      chooseDate: 'Sélectionnez une date',
      chooseMonth: 'Sélectionnez un mois',
      chooseTime: 'Choisissez une date',
      enterNumbers: 'Entrez des nombres',
      enterUrl: 'Entrez une URL',
      enterPassword: 'Entrez un mot de passe',
      chooseColor: 'Choisissez une couleur',
      chooseOption: 'Sélectionnez une option',
      chooseOptions: 'Sélectionnez des options dans la liste',
      npsTitle: 'Recommanderiez-vous notre service à des amis?',
      cesTitle: 'À quel point était-il facile de résoudre votre problème aujourd\'hui?',
      csatTitle: 'Êtes-vous satisfait de votre récente interaction avec notre entreprise?'
    }
}

}
